var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-6 h-6"},[_c(_vm.activeIcon,{tag:"component",class:[
			_vm.iconClasses,
			'w-6 h-6'
		]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }